import './pagination.scss';

class Pagination {
    constructor (container, options) {
        this.$container = container;
        this.paginationMobileRendered = false;
        this.paginationDesktopRendered = false;

        const settings = {
            paginationAttr: '[data-pagination="pagination"]',
            selectPaginationAttr: '[data-pagination="select-pagination"]'
        };

        this.settings = Object.assign({}, settings, options);

        this.$pagination = this.$container.querySelector(this.settings.paginationAttr);
        this.$selectPagination = this.$container.querySelector(this.settings.selectPaginationAttr);
    }

    check (callback) {
        this.paginationMobileRendered = false;
        this.paginationDesktopRendered = false;

        const setMobile = () => {
            if (this.paginationMobileRendered === false) {
                const $select = this.$container.querySelector('select');

                if ($select) {
                    import('../../components/form/select').then(({ Select }) => {
                        const newSelect = new Select($select);
                        newSelect.initialize();
                        this.paginationMobileRendered = true;
                        this.setSelectPaginationEvents(callback);
                    });
                }
            }
        };

        const setDesktop = () => {
            if (this.paginationDesktopRendered === false) {
                this.setPaginationEvents(callback); // Desktop
                this.paginationDesktopRendered = true;
            }
        };

        if (window.mediaMatch[768].matches) {
            setDesktop();
        } else {
            setMobile();
        }

        window.mediaMatch[768].addEventListener('change', (match) => {
            if (match.matches) {
                setDesktop();
            } else {
                setMobile();
            }
        });
    }

    setSelectPaginationEvents (callback) {
        this.$selectPagination = this.$container.querySelector(this.settings.selectPaginationAttr);

        if (this.$selectPagination) {
            const $select = this.$selectPagination.querySelector('select');

            $select.addEventListener('change', () => {
                if (typeof callback === 'function') {
                    callback($select.value);
                }
            });
        }
    }

    setPaginationEvents (callback) {
        this.$pagination = this.$container.querySelector(this.settings.paginationAttr);

        if (this.$pagination) {
            this.$pagination.addEventListener('click', (event) => {
                if (event.target.href !== 'undefined') {
                    event.preventDefault();

                    if (typeof callback === 'function') {
                        callback(event.target.href);
                    }
                }
            });
        }
    }
}

export { Pagination };
